<template>
    <ion-content>
      <modal name="create-address" width="90%" height="80%">
      <AddressComponent :isModal="true" :userId="customerId" :customer="customerData" :addressType="selectedAddressType"
        @address="addressAdded">
      </AddressComponent>
    </modal>
      <modal name="list-address" width="90%" height="80%">
        <AddressList :isModal="true" :userId="customerId" :addressType="selectedAddressType"
          @address-selected="handleSelectedAddress" @create-address="handleCreateAddress">
        </AddressList>
      </modal>
      <ion-loading v-if="spinner" cssClass="my-custom-class"
        :message="$t('frontend.tooltips.loadRestaurant')"></ion-loading>
      <ion-header v-if="!isModal">
        <ion-toolbar>
          <ion-title>Add Credit Card</ion-title>
        </ion-toolbar>
      </ion-header>
      <div :key="contentUpdate">
        <ion-grid>
          <ion-row>
            <ion-col size="12">
              <ion-card>
                <ion-card-content>
                  <form @submit.prevent="submitForm">
                    <ion-item>
                      <ion-label position="floating">Card Number</ion-label>
                      <ion-input
                      class="input-style"
                        type="text"
                        maxlength="19"
                        inputmode="numeric"
                        :value="cardNumber"
                        @input="cardNumber = $event.target.value; maskCardNumber"
                        placeholder="1234 5678 9012 3456"
                        required
                      ></ion-input>
                    </ion-item>

                    <ion-row>
                      <ion-col>                    
                        <ion-item>
                          <ion-label position="floating">Expiration Date (MM/YY)</ion-label>
                          <ion-datetime display-format="MM-YY" :value="expirationDate" :max="dateTodaymax + 30"
                          @ionChange="dateChanged($event.target.value)"></ion-datetime>
                      </ion-item>
                      </ion-col>
                      <ion-col>
                        <ion-item>
                          <ion-label position="floating">CVV</ion-label>
                          <ion-input
                          class="input-style"
                            type="password"
                            maxlength="4"
                            inputmode="numeric"
                            :value="cvv"
                            @input="cvv = $event.target.value;"
                            placeholder="123"
                            required
                          ></ion-input>
                        </ion-item>
                      </ion-col>
                    </ion-row>
  
                      <ion-row>
                        <ion-col>                    
                          <ion-item>
                          <!-- <ion-label>Name on card</ion-label> -->
                          <ion-label position="floating">Fist Name</ion-label>
                          <ion-input
                          class="input-style"
                            type="text"
                            :value="firstName"
                            @input="firstName = $event.target.value;"
                            placeholder="John Doe"
                            required
                          ></ion-input>
                        </ion-item>
                      </ion-col>
                      <ion-col>

                        <ion-item>
                          <ion-label position="floating">Midde Name</ion-label>
                          <ion-input
                          class="input-style"
                            type="text"
                            :value="middleName"
                            @input="middleName = $event.target.value;"
                            placeholder="John Doe"
                            required
                          ></ion-input>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-item>
                      <ion-label position="floating">Last Name</ion-label>
                      <ion-input
                      class="input-style"
                        type="text"
                        :value="lastName"
                        @input="lastName = $event.target.value;"
                        placeholder="John Doe"
                        required
                      ></ion-input>
                    </ion-item>

                    <ion-card>
                      <ion-card-header style="text-align: left">
                        <ion-card-title>{{ $t('backoffice.form.fields.billingAddress') }}</ion-card-title>
                        <ion-card-subtitle v-if="!customerId">{{ $t('backoffice.form.fields.selectCustomerAttachBillingAddress') }}</ion-card-subtitle>

                      </ion-card-header>
                      <ion-card-content>
                        <div style="text-align: left" v-if="customer?.billingAddress != null">
                          <p class="address-display"><span>{{ $t('backoffice.form.fields.selectedAddress') }}</span> {{ getDisplayAddress(customer?.billingAddress)
                            }}
                          </p>
                        </div>
                        <ion-button @click="showListOfAddresses('billing')"
                          size="small" fill="clear">
                          <span style="text-transform: capitalize;">{{ customerId?.billingAddress !== null ? $t('backoffice.form.fields.changeAddress') : $t('backoffice.form.fields.addAddress') }}
                            {{ $t('backoffice.form.fields.billingAddress') }}</span>
                        </ion-button>
                      </ion-card-content>
                    </ion-card>
  
                    <!-- <ion-item>
                      <ion-label position="floating">Billing Address</ion-label>
                      <ion-textarea
                        v-model="billingAddress"
                        placeholder="123 Main Street, City, State, ZIP"
                        required
                      ></ion-textarea>
                    </ion-item> -->
  
                    <ion-button expand="block"  @click="submitForm">
                      Save Card
                    </ion-button>
                  </form>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </template>
  
  <script>
  import AddressComponent from '../components/AddressComponent.vue'
  import AddressList from "../../frontend/components/AddressList.vue";
  import { UserUtil } from "../../backoffice/utils/user";
  import {payAuthorizeNet} from "../../backoffice/api/payments";
  import cardValidator from 'card-validator';
  import { DateTime } from 'luxon';
  import Swal from "sweetalert2";
  import { Api } from '../../backoffice/api/api';

  export default {
    name: 'CreditCardForm',
    props:{
      clientId:{
        type: String,
        default: ''
      },
      customerr:{
        type: Object,
        default: null
      },
      creditCardId: { // Añadir la prop creditCardId
        type: String,
        default: null
      },
      userId:{
        type: String
      },
      isModal:{
        type: Boolean,
        default: false,
      },
    },
    components:{
      AddressList,
      AddressComponent
    },
    data() {
      return {
        dateTodaymax: new Date().getFullYear(),
        cardNumber: "",
        expirationDate: "",
        cvv: "",
        nameOnCard: "",
        firstName: "",
        middleName: "",
        lastName: "",
        billingAddress: "",
        selectedAddressType: 'billing',
        customerId: this.$route.params.customerId || null,
        customerData: {},
        customer: {
          id: '',
          customerCompanyName: "",
          name: "",
          email: "",
          address: "",
          phone: "",
          projectName: "",
          addres1: "",
          addres2: "",
          state: "",
          city: "",
          country: "",
          county: "",
          zipCodeFlag: "",
        },
        contentUpdate: Math.random(),
        defaultAddresses: null,
        paymentMethod: 'card',
        spinner: false
      };
    },
    watch: {
      'paymentMethod': {
        handler(value) {
          value
        },
        immediate: true
      },
    },
    computed: {
      payMethod () {
        return this.$store?.state?.restaurantActive?.payMethod ?? this.MethodPay
      },
    },
    created: async function(){
      // console.log("creditCardId", this.clientId)
      // if(this.creditCardId){
        const data = await Api.fetchById('subscription', this.creditCardId)
        const dataEdit = data.data;
        // console.log(dataEdit)
        if(dataEdit){
          this.cardNumber = dataEdit?.tokenizeResp?.i4go_maskedcard
          this.firstName = dataEdit?.request?.customer?.firstName;
          this.lastName = dataEdit?.request?.customer?.lastName;
        }
      //   //const data = this.$store.state.backConfig.subscriber.find(s => s._id === this.creditCardId);
      //   // this.customer.id = this.id;
      //   // this.cardNumber =
      // }
      this.customerData = this.$store.state.customer
      // console.log(this.customerData)

      if (this.$route.params.customerId.length > 0) {
        this.updateDefaultAddresses(this.$route.params.customerId);
      }
    },
    methods: {
      isValidCreditCard(number) {
            let numberValidation = cardValidator.number(number);

            if (!numberValidation.isPotentiallyValid) {

                this.renderInvalidCardNumber();
            }

            if (numberValidation.card) {
                this.creditCardError = '';
                this.creditCardIcon = '';
                this.creditCardIcon = this.getCardBrandIcon(numberValidation.card.type.toLowerCase());
            }

            return numberValidation.isValid;
        },

        renderInvalidCardNumber() {
            this.creditCardIcon = '';
            this.creditCardError = 'Invalid credit card number';
        },

        getCardBrandIcon(brand) {
            if (brand == 'american-express') {
                return 'fa:cc-amex';
            } else if (brand == 'jcb') {
                return 'logos:jcb';
            } else if (brand == 'mastercard') {
                return 'logos:mastercard';
            } else if (brand == 'discover') {
                return 'fa-brands:cc-discover';
            } else if (brand == 'diners-club') {
                return 'fa6-brands:cc-diners-club';
            }
            return '';
        },

      
      /**
       * Handle the added address
       */
       addressAdded(address) {
        if (!address) {
          return;
        }
        //console.log('addressAdded', address);
        if (this.selectedAddressType == 'billing') {
          //mapping this just for consistency but will create a new field to hold the values
          this.customer.addres1 = address.street1;
          this.customer.addres2 = address.street2;
          //this.customer.addres3 = address.street3;
          this.customer.city = address.city;
          this.customer.county = address.country;
          this.customer.state = address.state;
          this.customer.zipCodeFlag = address.zip;
          this.customer.country = address.country;
          this.customer.billingAddress = address;
        }
        this.contentUpdate++;

        //handle update on shipping cost
        //put the code here
      },
      showListOfAddresses(type) {
        this.selectedAddressType = type;
        this.$modal.show('list-address');
      },

      handleSelectedAddress(address) {
        // console.log(address)
        this.addressAdded(address);
        this.$modal.hide('list-address');
      },

      /**
       * Handle creation of address request from list
       */
      handleCreateAddress(addressType) {
        this.$modal.hide('list-address');
        this.showAddressModal(addressType);
      },

      getDisplayAddress(address) {
        const result = `${address.street1} ${address.street2} ${address.street3} ${address.city}, ${address.state}, ${address.county}, ${address.country} ${address.zip}`;
        return result;
      },

      /**
        * Show address modal for adding an address
        */
      showAddressModal(type) {
        this.selectedAddressType = type;
        this.$modal.show('create-address');
      },

      updateDefaultAddresses(userId) {
        if (!userId || userId.length == 0) return;

        UserUtil.getDefaultAddresses(userId).then(data => {
          this.defaultAddresses = data;
          //console.log('defaultAddresses', this.defaultAddresses);

          //process it
          this.selectedAddressType = 'billing';
          this.addressAdded(this.defaultAddresses.billingAddress);

          this.selectedAddressType = 'shipping';
          this.addressAdded(this.defaultAddresses.shippingAddress);
        });
      },

      maskCardNumber() {
        // Remove all non-numeric characters
        let rawNumber = this.cardNumber.replace(/\D/g, "");
      
        // Mask all but the last 4 digits
        if (rawNumber.length > 4) {
          let maskedPart = rawNumber
            .slice(0, rawNumber.length - 4)
            .replace(/./g, "*");
          let visiblePart = rawNumber.slice(-4);
      
          // Format the number into groups of 4 with spaces
          this.cardNumber = maskedPart
            .replace(/(.{4})/g, "$1 ")
            .trim() + " " + visiblePart;
        } else {
          // Format the raw number into groups of 4 with spaces
          this.cardNumber = rawNumber.replace(/(.{4})/g, "$1 ").trim();
        }
      },

      dateChanged(datetime) {
        this.expirationDate = new Date(datetime);
      },

      getCCExpiry(dateString) {
        const expiryDate = new Date(dateString);

        const year = expiryDate.getFullYear();
        const month = expiryDate.getMonth() + 1;
        return `${year}-${month < 10 ? '0' : ''}${month}`;
      },
      async submitForm() {
        if (this.paymentMethod === 'card' && !this.isValidCreditCard(this.cardNumber)) {
          this.creditCardError = 'Invalid credit card number';
          Swal.close();
          return;
        }
        this.spinner = true;

        this.creditCardError = '';

        let cardEx = new Date()
        if (this.paymentMethod == 'card') {
          cardEx = this.expirationDate
          this.expirationDate = this.getCCExpiry(this.expirationDate)
        }
        // Create a payload for saving
        const payload = {
          cardNumber: this.cardNumber,
          expirationDate: this.expirationDate,
          cardSecurityCode: this.cvv,
          //nameOnCard: this.nameOnCard,
          //billingAddress: this.billingAddress,
          paymentMethod: this.paymentMethod,
          isRecurring: false,
          restaurantId: this.$store.state.backConfig.restaurant._id,
          payMethod: this.payMethod,
          total: 0,
          tax: 0,
          tip: 0,
          cardExpirationDateF1: DateTime.fromJSDate(new Date(cardEx)).toFormat("MMyy"),
          cardExpirationDateF2: DateTime.fromJSDate(new Date(cardEx)).toFormat("yyyy-MM"),
          cardExpirationDateF3: DateTime.fromJSDate(new Date(cardEx)).toFormat("yyMM"),
          cardExpirationDateF4: DateTime.fromJSDate(new Date(cardEx)).toFormat("MM/yy"),
          products: [],
          firstName: this.firstName,
          lastName: this.lastName, //Pending
          address: this.customer.addres1,
          zip: this.customer.zipCodeFlag,
          customerId: this.customerData._id || this.clientId,
        };

        // console.log({payload},this.$store.state.restaurantActive)
  
        try {
          const response = await payAuthorizeNet.payOrder(payload);
          console.log({response})
          console.log(this.$store.state)
          if(response.status == 200){
            
            //close modal
            Swal.fire({
              icon: "success",
              title: 'Success',
              text: 'Card saved successfully',
              backdrop: false
            });
            this.$emit('close-modal');
            this.spinner = false;
            // this.$store.state.subscriptions.records.push(response.data.records);
            // this.$store.state.subscriptions.totalCount.push(response.data.totalCount);
              // this.$store.commit('setSubscription', {
              //   records: response.data.records || [], 
              //   totalCount: response.data.totalCount || []
              // });
            //this.$store.commit('setSubscription', response.data.totalCount);
          }
          // Make API call to Azure Function to save card details
          // const response = await fetch("https://<your-azure-function-url>", {
          //   method: "POST",
          //   headers: {
          //     "Content-Type": "application/json",
          //   },
          //   body: JSON.stringify(payload),
          // });
  
          // if (response.ok) {
          //   const result = await response.json();
          //   console.log("Card saved successfully:", result);
          //   // Display success message or redirect
          // } else {
          //   console.error("Error saving card:", response.statusText);
          //   // Handle error message
          // }
          this.spinner = false;
        } catch (error) {
          console.error("Error:", error);
          // Handle network errors
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ion-item {
    margin-bottom: 10px;
  }
  ion-button {
    margin-top: 20px;
  }

 
  </style>
  